export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function hasMeaningfulValue(value: unknown): boolean {
  return value !== undefined && value !== null && value !== '';
}

/** 递归移除空对象；undefined/null/空字符串 字段一并剔除 */
export function stripEmptyObjects<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => stripEmptyObjects(item)) as T;
  }
  if (!isPlainObject(value)) {
    return value;
  }

  const next: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(value)) {
    if (!hasMeaningfulValue(child)) continue;
    const cleaned = stripEmptyObjects(child);
    if (isPlainObject(cleaned) && Object.keys(cleaned).length === 0) continue;
    next[key] = cleaned;
  }
  return next as T;
}
